import { Highlight } from "prism-react-renderer";
import ContentContainer from "src/components/Container/ContentContainer";
import { SectionDivider } from "src/components/Divider";
import { ImageGallery } from "src/components/ImageGallery";
import UnorderedList from "src/components/UnorderedList";

interface Props {}

const AboutMe: React.FC<Props> = () => {
    return (
        <>
            <ContentContainer maxWidth={"50rem"} padding={"0 32px"}>
                <p>
                    Hi! I'm Tim, a software engineer at Google and a computer
                    science graduate from the University of New South Wales
                    (UNSW). I'm currently working on the Google Open Source
                    Security team, where I help secure Google's consumption of
                    open source software.
                </p>
                <p>
                    I first fell in love with software engineering after writing
                    some awful games in Unity and web scrapers in Python as a
                    high schooler.
                </p>
            </ContentContainer>
            <ContentContainer maxWidth={"50rem"} padding={"0 32px"}>
                <p>What's my setup? Why, I am glad you asked 🤓.</p>
                <ContentContainer maxWidth={950} padding={"0px 0px 12px 0px"}>
                    <Highlight
                        code={`
      /\\          tym@tym-desktop
     /  \\         ---------------
    /\\   \\        OS: Arch Linux x86_64
   /      \\       Kernel: Linux 6.19.6-arch1-1
  /   ,,   \\      Packages: 735 (pacman)
 /   |  |  -\\     Shell: zsh 5.9
/_-''    ''-_\\    WM: Hyprland 0.54.1 (Wayland)
                  Display (LEN T32p-20): 3840x2160 in 32", 60 Hz [External]
                  Display (DELL G3223Q): 3840x2160 in 32", 60 Hz [External]
                  Theme: Arc-Dark [GTK3]
                  Terminal: kitty 0.45.0
                  CPU: AMD Ryzen 5 5600X (12) @ 4.65 GHz
                  GPU: NVIDIA GeForce GTX 1060 6GB [Discrete]
                  Disk (/): 22.90 GiB / 1.82 TiB (1%) - btrfs
                    `}
                        language="bash"
                    >
                        {({
                            className,
                            style,
                            tokens,
                            getLineProps,
                            getTokenProps,
                        }) => (
                            <pre className={className} style={style}>
                                {tokens.map((line, i) => (
                                    <div {...getLineProps({ line, key: i })}>
                                        {line.map((token, key) => (
                                            <span
                                                {...getTokenProps({
                                                    token,
                                                    key,
                                                })}
                                            />
                                        ))}
                                    </div>
                                ))}
                            </pre>
                        )}
                    </Highlight>
                </ContentContainer>
            </ContentContainer>
        </>
    );
};

export default AboutMe;
